import React, { useState, useEffect } from 'react';
import AdminLayout from '../../components/Layout';
import { settingsAPI } from '../../utils/api';
import '../../../styles/tools.css';
import { Tabs, Tab, Box, Typography, TextField, Paper, Button } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

// Компонент с табами
function TabPanel(props) {
    const { children, value, index, ...other } = props;
  
    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`tools-tabpanel-${index}`}
            aria-labelledby={`tools-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box sx={{ p: 0 }}>
                    {children}
                </Box>
            )}
        </div>
    );
}

const Tools = () => {
    const [settings, setSettings] = useState({
        headerCode: '',
        footerCode: ''
    });
    const [isLoading, setIsLoading] = useState(false);
    const [message, setMessage] = useState({ type: '', text: '' });
    const [tabValue, setTabValue] = useState(0);
    const [copied, setCopied] = useState(false);

    // Получаем текущий домен из переменных окружения или window.location
    const currentDomain = process.env.REACT_APP_FULL_DOMAIN || 
                          process.env.REACT_APP_API_URL || 
                          window.location.origin;
    
    // Формируем URL постбэка, избегаем дублирования 'api'
    const getPostbackUrl = () => {
        // Проверяем, заканчивается ли currentDomain на /api
        if (currentDomain.endsWith('/api')) {
            return `${currentDomain}/postback?click_id={subid1}&status={status}&payout={payout}&currency={currency}`;
        } else {
            return `${currentDomain}/api/postback?click_id={subid1}&status={status}&payout={payout}&currency={currency}`;
        }
    };
    
    const postbackUrl = getPostbackUrl();

    useEffect(() => {
        fetchSettings();
    }, []);

    const fetchSettings = async () => {
        try {
            const response = await settingsAPI.getToolsSettings();
            setSettings(response);
        } catch (error) {
            setMessage({
                type: 'error',
                text: 'Ошибка при загрузке настроек'
            });
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        try {
            await settingsAPI.saveToolsSettings(settings);
            setMessage({
                type: 'success',
                text: 'Настройки успешно сохранены'
            });
        } catch (error) {
            setMessage({
                type: 'error',
                text: 'Ошибка при сохранении настроек'
            });
        }
        setIsLoading(false);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setSettings(prev => ({
            ...prev,
            [name]: value
        }));
    };
    
    const handleTabChange = (event, newValue) => {
        setTabValue(newValue);
    };
    
    const copyToClipboard = (text) => {
        navigator.clipboard.writeText(text).then(() => {
            setCopied(true);
            setTimeout(() => setCopied(false), 2000);
        });
    };

    return (
        <AdminLayout>
            <div className="tools-container">
                <div className="tools-header">
                    <h1 className="tools-title">Инструменты</h1>
                </div>

                {message.text && (
                    <div className={`message ${message.type}`}>
                        {message.text}
                    </div>
                )}

                <Box sx={{ 
                    width: '100%', 
                    mb: 3,
                }}>
                    <Tabs 
                        value={tabValue} 
                        onChange={handleTabChange} 
                        aria-label="tools tabs"
                        sx={{ 
                            borderBottom: 1, 
                            borderColor: 'divider',
                            '& .MuiTab-root': {
                                fontWeight: 600,
                                fontSize: '16px',
                                textTransform: 'uppercase',
                                minWidth: 150,
                                py: 2
                            },
                            '& .Mui-selected': {
                                color: '#1976d2',
                                fontWeight: 700
                            },
                            '& .MuiTabs-indicator': {
                                height: 3,
                                backgroundColor: '#1976d2'
                            }
                        }}
                    >
                        <Tab label="Код вставки" id="tools-tab-0" aria-controls="tools-tabpanel-0" />
                        <Tab label="Postback" id="tools-tab-1" aria-controls="tools-tabpanel-1" />
                    </Tabs>
                </Box>

                <TabPanel value={tabValue} index={0}>
                    <div className="tools-content">
                        <form onSubmit={handleSubmit}>
                            <div className="form-group">
                                <label htmlFor="headerCode">
                                    Код для вставки в head
                                    <span className="help-text">
                                        (например, метатеги или скрипты аналитики)
                                    </span>
                                </label>
                                <textarea
                                    id="headerCode"
                                    name="headerCode"
                                    value={settings.headerCode}
                                    onChange={handleChange}
                                    rows="6"
                                    placeholder="<!-- Вставьте код для head -->"
                                />
                            </div>

                            <div className="form-group">
                                <label htmlFor="footerCode">
                                    Код для вставки в footer
                                    <span className="help-text">
                                        (например, код счетчиков)
                                    </span>
                                </label>
                                <textarea
                                    id="footerCode"
                                    name="footerCode"
                                    value={settings.footerCode}
                                    onChange={handleChange}
                                    rows="6"
                                    placeholder="<!-- Вставьте код для footer -->"
                                />
                            </div>

                            <div className="form-actions">
                                <button 
                                    type="submit" 
                                    className="btn-primary"
                                    disabled={isLoading}
                                >
                                    {isLoading ? 'Сохранение...' : 'Сохранить'}
                                </button>
                            </div>
                        </form>
                    </div>
                </TabPanel>

                <TabPanel value={tabValue} index={1}>
                    <div className="tools-content">
                        <div className="form-group">
                            <label>
                                Инструкция по использованию Postback
                                <span className="help-text">
                                    (для настройки оповещений от партнерской сети)
                                </span>
                            </label>
                            <div className="white-box">
                                <p>
                                    Postback - это механизм для получения информации о конверсиях от партнерской сети.
                                    Настройте в вашей партнерской программе следующий URL для отправки уведомлений о статусах конверсий:
                                </p>
                                
                                <h3>URL для постбэка</h3>
                                <Paper sx={{ 
                                    p: 2, 
                                    mb: 3, 
                                    backgroundColor: '#f5f5f5',
                                    border: '1px solid #e0e0e0',
                                    borderRadius: '4px'
                                }}>
                                    <Box sx={{ display: 'flex', alignItems: 'center', mb: 1 }}>
                                        <Typography variant="subtitle1" sx={{ flexGrow: 1, fontWeight: 'bold' }}>
                                            URL для постбэка:
                                        </Typography>
                                        <Button 
                                            variant="contained" 
                                            size="small" 
                                            startIcon={<ContentCopyIcon />}
                                            onClick={() => copyToClipboard(postbackUrl)}
                                            color={copied ? "success" : "primary"}
                                        >
                                            {copied ? "Скопировано!" : "Копировать"}
                                        </Button>
                                    </Box>
                                    <TextField
                                        fullWidth
                                        variant="outlined"
                                        value={postbackUrl}
                                        InputProps={{
                                            readOnly: true,
                                        }}
                                        size="small"
                                    />
                                </Paper>
                                
                                <h3>Параметры URL:</h3>
                                <Box sx={{ mb: 3 }}>
                                    <Paper sx={{ p: 2, borderRadius: '4px' }}>
                                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                            <li style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                                    <Box sx={{ minWidth: '120px', fontWeight: 'bold', color: '#555' }}>
                                                        {'{subid1}'}
                                                    </Box>
                                                    <Box sx={{ flex: 1 }}>
                                                        - ID клика (обязательный параметр)
                                                    </Box>
                                                </Box>
                                            </li>
                                            <li style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                                    <Box sx={{ minWidth: '120px', fontWeight: 'bold', color: '#555' }}>
                                                        {'{status}'}
                                                    </Box>
                                                    <Box sx={{ flex: 1 }}>
                                                        - Статус конверсии (подтвержденная, отклоненная, холд и т.д.)
                                                    </Box>
                                                </Box>
                                            </li>
                                            <li style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                                    <Box sx={{ minWidth: '120px', fontWeight: 'bold', color: '#555' }}>
                                                        {'{payout}'}
                                                    </Box>
                                                    <Box sx={{ flex: 1 }}>
                                                        - Сумма выплаты
                                                    </Box>
                                                </Box>
                                            </li>
                                            <li style={{ padding: '8px 0' }}>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap' }}>
                                                    <Box sx={{ minWidth: '120px', fontWeight: 'bold', color: '#555' }}>
                                                        {'{currency}'}
                                                    </Box>
                                                    <Box sx={{ flex: 1 }}>
                                                        - Валюта выплаты
                                                    </Box>
                                                </Box>
                                            </li>
                                        </ul>
                                    </Paper>
                                </Box>
                                
                                <h3>Поддерживаемые статусы:</h3>
                                <Box sx={{ mb: 3 }}>
                                    <Paper sx={{ p: 2, borderRadius: '4px' }}>
                                        <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                                            <li style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                                    <Box sx={{ minWidth: '250px', fontWeight: 'bold' }}>
                                                        <span style={{ color: '#4caf50' }}>confirmed</span> / <span style={{ color: '#4caf50' }}>approved</span>
                                                    </Box>
                                                    <Box sx={{ flex: 1 }}>
                                                        - Подтвержденная конверсия
                                                    </Box>
                                                </Box>
                                            </li>
                                            <li style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                                    <Box sx={{ minWidth: '250px', fontWeight: 'bold' }}>
                                                        <span style={{ color: '#f44336' }}>rejected</span> / <span style={{ color: '#f44336' }}>declined</span> / <span style={{ color: '#f44336' }}>canceled</span>
                                                    </Box>
                                                    <Box sx={{ flex: 1 }}>
                                                        - Отклоненная конверсия
                                                    </Box>
                                                </Box>
                                            </li>
                                            <li style={{ padding: '8px 0', borderBottom: '1px solid #eee' }}>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                                    <Box sx={{ minWidth: '250px', fontWeight: 'bold' }}>
                                                        <span style={{ color: '#ff9800' }}>hold</span> / <span style={{ color: '#ff9800' }}>pending</span> / <span style={{ color: '#ff9800' }}>waiting</span>
                                                    </Box>
                                                    <Box sx={{ flex: 1 }}>
                                                        - Конверсия на удержании
                                                    </Box>
                                                </Box>
                                            </li>
                                            <li style={{ padding: '8px 0' }}>
                                                <Box sx={{ display: 'flex', flexWrap: 'wrap', alignItems: 'center' }}>
                                                    <Box sx={{ minWidth: '250px', fontWeight: 'bold' }}>
                                                        <span style={{ color: '#9e9e9e' }}>trashed</span> / <span style={{ color: '#9e9e9e' }}>trash</span> / <span style={{ color: '#9e9e9e' }}>invalid</span>
                                                    </Box>
                                                    <Box sx={{ flex: 1 }}>
                                                        - Треш-конверсия
                                                    </Box>
                                                </Box>
                                            </li>
                                        </ul>
                                    </Paper>
                                </Box>
                                
                                <div className="info-box" style={{
                                    backgroundColor: '#e8f4fd',
                                    border: '1px solid #cce5ff',
                                    borderRadius: '4px',
                                    padding: '12px',
                                    marginTop: '16px'
                                }}>
                                    <h4 style={{ margin: '0 0 8px 0', color: '#0060b6' }}>Примечание</h4>
                                    <p style={{ margin: '0 0 8px 0' }}>
                                        Разные партнерские сети могут использовать различные названия статусов. 
                                        Система автоматически сопоставляет схожие статусы при обработке.
                                    </p>
                                    <p style={{ margin: '0' }}>
                                        Если ваша партнерская сеть использует другие статусы, свяжитесь с администратором 
                                        для настройки их правильной обработки.
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </TabPanel>
            </div>
        </AdminLayout>
    );
};

export default Tools; 